import React, { useState, useEffect } from "react";
import getState from "./Flux.js";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./config";

export const Context = React.createContext(null);

const injectContext = (PassedComponent) => {
	const StoreWrapper = (props) => {
		//this will be passed as the contenxt value
		const [state, setState] = useState(
			getState({
				getStore: () => state.store,
				getActions: () => state.actions,
				setStore: (updatedStore) =>
					setState({
						store: Object.assign(state.store, updatedStore),
						actions: { ...state.actions },
					}),
			})
		);

		useEffect(() => {
			// Verificar la caducidad del token y usuario
			const checkSessionValidity = () => {
				const expirationTime = localStorage.getItem('sessionExpiration');
				const currentTime = new Date().getTime();

				// Si no hay tiempo de expiración o el tiempo actual es mayor al de expiración
				if (!expirationTime || currentTime > parseInt(expirationTime)) {
					// Limpiar localStorage
					localStorage.removeItem('usuarioActual');
					localStorage.removeItem('token');
					localStorage.removeItem('sessionExpiration');
					
					// Limpiar store usando setState directamente
					setState(state => ({
						...state,
						store: {
							...state.store,
							usuarioActual: null,
							token: null
						}
					}));
					
					return false;
				}
				return true;
			};

			let firebaseChecked = false;

			// Listener para cambios en el estado de autenticación de Firebase
			const unsubscribe = onAuthStateChanged(auth, (user) => {
				firebaseChecked = true;
				
				if (user) {
					// Usuario autenticado en Firebase
					if (checkSessionValidity()) {
						// Cargar datos del localStorage si la sesión es válida
						const usuarioActual = localStorage.getItem("usuarioActual");
						const token = localStorage.getItem("token");
						
						if (usuarioActual && token) {
							try {
								const parsedUsuario = JSON.parse(usuarioActual);
								if (parsedUsuario && parsedUsuario.nombre) {
									setState(state => ({
										...state,
										store: {
											...state.store,
											usuarioActual: parsedUsuario,
											token: token
										}
									}));
								}
							} catch (error) {
								console.error("Error al parsear usuarioActual:", error);
								// Limpiar datos corruptos
								localStorage.removeItem('usuarioActual');
								localStorage.removeItem('token');
								localStorage.removeItem('sessionExpiration');
								setState(state => ({
									...state,
									store: {
										...state.store,
										usuarioActual: null,
										token: null
									}
								}));
							}
						}
					}
				} else {
					// Usuario no autenticado en Firebase, limpiar todo
					localStorage.removeItem('usuarioActual');
					localStorage.removeItem('token');
					localStorage.removeItem('sessionExpiration');
					
					setState(state => ({
						...state,
						store: {
							...state.store,
							usuarioActual: null,
							token: null
						}
					}));
				}
			});

			// Si después de 2 segundos Firebase no ha respondido, verificar la sesión manualmente
			const timeoutId = setTimeout(() => {
				if (!firebaseChecked) {
					checkSessionValidity();
				}
			}, 2000);

			// Verificar la sesión cada minuto
			const intervalId = setInterval(checkSessionValidity, 60000);

			// Cleanup del intervalo, timeout y unsubscribe
			return () => {
				clearInterval(intervalId);
				clearTimeout(timeoutId);
				unsubscribe();
			};
		}, []);

		// The initial value for the context is not null anymore, but the current state of this component,
		// the context will now have a getStore, getActions and setStore functions available, because they were declared
		// on the state of this component
		return (
			<Context.Provider value={state}>
				<PassedComponent {...props} />
			</Context.Provider>
		);
	};
	return StoreWrapper;
};

export default injectContext;
